module.exports = __webpack_public_path__ + "static/media/closeIcon.129490b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/closeIcon.svg
// module id = 1536
// module chunks = 0